import { OnboardingStepCommon, Content, VideoTour } from './OnboardingStepCommon';

const OnboardingStepFour = ({ videoRef }) => {
  return (
    <OnboardingStepCommon>
      <VideoTour ref={videoRef} name='onboarding-4' />
      <Content>
        <small className='black'>Features you can try on the playground:</small>
        <h3>View Contract Overview</h3>
        <p>
          <small>
            Select Contract Overview on the toolbar to view a summary of the contract, 
            key issues and potentially missing clauses
          </small>
        </p>
      </Content>
    </OnboardingStepCommon>
  );
}

export default OnboardingStepFour;